import { useContext } from 'react';
import { ResponsiveContext } from '../../utils/responsive.es.js';

function useBreakpoint(size) {
  const state = useContext(ResponsiveContext);
  return !!state.breakpoints[size];
}

export { useBreakpoint };
//# sourceMappingURL=useBreakpoint.es.js.map
